<template>
    <a class="skip-link" :href="`#${mainContentId}`">
        {{ $t(`skipToContent`) }}
    </a>
</template>

<script setup lang="ts">
const { mainContentId = 'main' } = defineProps<{ mainContentId?: string }>();
</script>

<style scoped lang="postcss">
.skip-link {
    @apply border-solid bg-white block fixed top-4 left-4 opacity-0 transition-opacity focus-visible:opacity-100 text-wl-base-dark-grey underline text-xs font-bold px-3 py-2 border-4 rounded-lg border-[#0957C2];
    &:focus-visible {
        z-index: 1000;
    }
}
</style>
